<template>
  <div class="ai-skills-panel">
    <div class="ai-skills-header">
      <span class="ai-skills-title">
        <span class="ai-glyph" aria-hidden="true">&#129302;</span>
        AI Skills (auto-filled)
      </span>
      <span class="ai-skills-readonly-badge">read-only</span>
      <a class="ai-refresh-btn" :class="{ 'is-loading-spin': loading }" title="Refresh AI skills" @click="fetchAiSkills">
        <span aria-hidden="true">&#8635;</span>
      </a>
    </div>

    <div v-if="loading && !hasLoadedOnce" class="ai-skills-muted">Loading&hellip;</div>

    <div v-else-if="error" class="ai-skills-muted">Could not load AI skills.</div>

    <div v-else-if="isEmpty" class="ai-skills-muted">Not extracted yet</div>

    <div v-else>
      <div v-if="mandatory_skills.length > 0">
        <div class="bold is-underlined is-size-6">Mandatory :</div>
        <div class="tag is-rounded m-1" v-for="(ai_skill, idx) in mandatory_skills" :key="'m-' + idx">
          {{ ai_skill.skill.name }}
        </div>
      </div>
      <div v-for="(ai_skills, group_name) in grouped_skills" :key="'g-' + group_name">
        <div class="bold is-underlined is-size-6">Group {{ group_name }} :</div>
        <div class="tag is-rounded m-1" v-for="(ai_skill, idx) in ai_skills" :key="'g-' + group_name + '-' + idx">
          {{ ai_skill.skill.name }}
        </div>
      </div>
      <div v-if="optional_skills.length > 0">
        <div class="bold is-underlined is-size-6">Optional :</div>
        <div class="tag is-rounded m-1" v-for="(ai_skill, idx) in optional_skills" :key="'o-' + idx">
          {{ ai_skill.skill.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ai-display-skills',
  props: {
    position_id: {
      type: [Number, String],
      required: true
    },
    current_company_id: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      ai_skills: [],
      loading: false,
      hasLoadedOnce: false,
      error: false
    }
  },
  computed: {
    isEmpty () {
      return this.ai_skills.length == 0
    },
    mandatory_skills () {
      return this.ai_skills.filter(el => !el.group_name && el.importance > 7)
    },
    optional_skills () {
      return this.ai_skills.filter(el => !el.group_name && el.importance <= 7 && el.importance != 5)
    },
    grouped_skills () {
      return this.ai_skills.reduce((prev, el) => {
        if (el.importance != 5 || !el.group_name) {
          return prev
        }
        prev[el.group_name] = prev[el.group_name] || []
        prev[el.group_name].push(el)
        return prev
      }, {})
    }
  },
  created () {
    this.fetchAiSkills()
  },
  methods: {
    fetchAiSkills () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.error = false
      this.$network_utils.getPositionAiSkills({
        position_id: this.position_id,
        current_company_id: this.current_company_id
      }).then(response => {
        this.ai_skills = response || []
        this.loading = false
        this.hasLoadedOnce = true
      }).catch(error => {
        console.error('Error loading AI skills:', error)
        this.ai_skills = []
        this.error = true
        this.loading = false
        this.hasLoadedOnce = true
      })
    }
  }
}
</script>
<style scoped>
.ai-skills-panel {
  margin-top: 20px;
  padding: 12px 16px;
  border: 1px dashed rgba(108, 99, 255, 0.4);
  border-radius: 8px;
  background: rgba(108, 99, 255, 0.05);
}
.ai-skills-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.ai-skills-title {
  font-weight: 700;
  font-size: 0.95rem;
  color: #4a45b0;
}
.ai-glyph {
  margin-right: 4px;
}
.ai-skills-readonly-badge {
  margin-left: 10px;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6c63ff;
  border: 1px solid rgba(108, 99, 255, 0.4);
  border-radius: 10px;
  padding: 1px 8px;
}
.ai-refresh-btn {
  margin-left: auto;
  cursor: pointer;
  font-size: 1.1rem;
  line-height: 1;
  color: #6c63ff;
  user-select: none;
}
.ai-refresh-btn.is-loading-spin {
  opacity: 0.5;
  pointer-events: none;
}
.ai-skills-muted {
  color: rgba(0, 0, 0, 0.45);
  font-size: 0.85rem;
  font-style: italic;
}
.is-underlined {
  text-decoration: underline;
}
.m-1 {
  margin: 0.25rem;
}
</style>
